var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent,{tag:"component",on:{"input":function($event){_vm.currentModal = ''}}}),_c('smart-tooltip',{ref:"smartTooltip",attrs:{"link":_vm.helpLink,"hide-activator":"","category":_vm.helpCategory,"type":_vm.helpType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }